import { Plano } from './plano.model';

export class Filtro {
    id : number;
    nomeProcesso: string;
    nrCpf: string;
    nomePessoa: string;
    dtSolicitacao: Date;
    nomeSituacao: string;
    idProcesso : number;
    status: number;
    plano : Plano;
    check: boolean;
    idContrato: number;
    dtCredito: string;
}